<template>
	<div>
		<bsh-datatable
			:columns="columns"
            :buttons="buttons"
			:link="$url+'/api/adm/entrega-destinos/datatable/'+$route.params.id"
            actionFild
            @selectRow="show"
            @show="show"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            columns: [
                {
                    label: 'Pedido',
                    field: 'pedido_id',
                    order: 'entrega_destinos.pedido_id',
                    sort: 'asc'
                },
                {
                    label: 'Cliente',
                    field: 'nome',
                    order: 'clientes.nome',
                    sort: 'asc'
                },
                {
                    label: 'Ordem',
                    field: 'ordem',
                    order: 'entrega_destinos.ordem',
                    sort: 'asc'
                },
                {
                    label: 'Cep',
                    field: 'cep',
                    order: 'entrega_destinos.cep',
                    sort: 'asc'
                },
                {
                    label: 'Bairro',
                    field: 'bairro',
                    order: 'entrega_destinos.bairro',
                    sort: 'asc'
                },
                {
                    label: 'Cidade',
                    field: 'cidade',
                    order: 'entrega_destinos.cidade',
                    sort: 'asc'
                },
                {
                    label: 'Estado',
                    field: 'estado',
                    order: 'entrega_destinos.estado',
                    sort: 'asc'
                },
                {
                    label: 'Logradouro',
                    field: 'logradouro',
                    order: 'entrega_destinos.logradouro',
                    sort: 'asc'
                },
                {
                    label: 'Complemento',
                    field: 'complemento',
                    order: 'entrega_destinos.complemento',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'show',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                },
            ]
    	}
	},
    methods: {
        show(dado){
            this.$emit('show', dado.id);
        }
    }
}
</script>
